export const CARD_VALIDATIONS = {
  cardholderName: {
    required: {
      message: 'Please enter cardholder name.',
      value: true
    }
  },
  cardNumber: {
    required: {
      message: 'Please enter a card number.',
      value: true
    },
    creditCardNumber: {
      message: 'Invalid card number, please try again.',
      value: true
    }
  },
  expirationMonth: {
    required: {
      message: 'Expiration month is required.',
      value: true
    }
  },
  expirationYear: {
    required: {
      message: 'Expiration year is required.',
      value: true
    }
  },
  securityCode: {
    required: {
      message: 'Please enter your 3 or 4 digit CVV code.',
      value: true
    },
    pattern: {
      message: 'Please enter a valid 3 or 4 digit CVV code.',
      value: /^\d{3,4}$/
    }
  }
};
